namespace GeniuzPOS.Administration {
    export interface CsParaForm {
        BizName: Serenity.StringEditor;
        BizNameEn: Serenity.StringEditor;
        BizAddressLine1: Serenity.StringEditor;
        BizAddressLine2: Serenity.StringEditor;
        BizAddressLine3: Serenity.StringEditor;
        RegId: Serenity.StringEditor;
        TelId: Serenity.StringEditor;
        FaxId: Serenity.StringEditor;
        Email: Serenity.EmailEditor;
        BizType: Serenity.RadioButtonEditor;
        VatFg: Serenity.EnumEditor;
        TaxInvName: Serenity.StringEditor;
        TaxId: Serenity.StringEditor;
        TaxInvAddrLine1: Serenity.StringEditor;
        TaxInvAddrLine2: Serenity.StringEditor;
        TaxInvAddrLine3: Serenity.StringEditor;
        BranchNo: Serenity.StringEditor;
        BranchNameDesc: Serenity.StringEditor;
        BranchNameDescEn: Serenity.StringEditor;
        BuildingNo: Serenity.StringEditor;
        BuildingNoEn: Serenity.StringEditor;
        BuildingName: Serenity.StringEditor;
        BuildingNameEn: Serenity.StringEditor;
        StreetName: Serenity.StringEditor;
        StreetNameEn: Serenity.StringEditor;
        District: Serenity.StringEditor;
        DistrictEn: Serenity.StringEditor;
        City: Serenity.StringEditor;
        CityEn: Serenity.StringEditor;
        Province: Serenity.StringEditor;
        ProvinceEn: Serenity.StringEditor;
        PostalCode: Serenity.StringEditor;
        CountryCode: Serenity.LookupEditor;
        ErpCompCode: Serenity.StringEditor;
        SlowMoveItenDate: Serenity.IntegerEditor;
    }

    export class CsParaForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.CsPara';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsParaForm.init)  {
                CsParaForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EmailEditor;
                var w2 = s.RadioButtonEditor;
                var w3 = s.EnumEditor;
                var w4 = s.LookupEditor;
                var w5 = s.IntegerEditor;

                Q.initFormType(CsParaForm, [
                    'BizName', w0,
                    'BizNameEn', w0,
                    'BizAddressLine1', w0,
                    'BizAddressLine2', w0,
                    'BizAddressLine3', w0,
                    'RegId', w0,
                    'TelId', w0,
                    'FaxId', w0,
                    'Email', w1,
                    'BizType', w2,
                    'VatFg', w3,
                    'TaxInvName', w0,
                    'TaxId', w0,
                    'TaxInvAddrLine1', w0,
                    'TaxInvAddrLine2', w0,
                    'TaxInvAddrLine3', w0,
                    'BranchNo', w0,
                    'BranchNameDesc', w0,
                    'BranchNameDescEn', w0,
                    'BuildingNo', w0,
                    'BuildingNoEn', w0,
                    'BuildingName', w0,
                    'BuildingNameEn', w0,
                    'StreetName', w0,
                    'StreetNameEn', w0,
                    'District', w0,
                    'DistrictEn', w0,
                    'City', w0,
                    'CityEn', w0,
                    'Province', w0,
                    'ProvinceEn', w0,
                    'PostalCode', w0,
                    'CountryCode', w4,
                    'ErpCompCode', w0,
                    'SlowMoveItenDate', w5
                ]);
            }
        }
    }
}
